import { TabProps } from "../types";

const Tab = ({ value, title, active, onClick}: TabProps): JSX.Element => {
  return (
     <a
        className={`p-5 flex items-center justify-center rounded-3xl text-base transition duration-300 ease-in-out transform  shadow hover:scale-105 cursor-pointer
          ${active ? "bg-magenta text-white " : "bg-transparent text-grey-200"}  min-w-[80px] h-12 
        `}
        onClick={() => onClick(value)}
      >
        {title}
      </a> 
  );
};

export default Tab;
